/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Radio, Row, Spin } from "antd";
import { useForm } from "react-hook-form";
import { InputField, InputPhone } from "../../../../../atoms/FormFields";
import { useEffect, useState } from "react";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  editData: any;
  contactIndex: number | null;
  contacts: any;
  setContactIndex: React.Dispatch<React.SetStateAction<number | null>>;
  setContacts: any;
}

interface FormValues {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  title: string;
  preferred_method_of_contact: string;
}

export default function AddContactPopUp(props: PropsType) {
  const {
    onClose,
    setContacts,
    editData,
    contactIndex,
    setContactIndex,
    contacts,
  } = props;
  const [loading, setLoading] = useState(false);
  const [methodContact, setMethodContact] = useState("any");
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    val.preferred_method_of_contact = methodContact;

    setTimeout(() => {
      if (contactIndex !== null) {
        if (contactIndex >= 0 && contactIndex < contacts.length) {
          const updatedContacts = contacts.map(
            (contact: any, index: number) => {
              if (index === contactIndex) {
                return {
                  ...contact,
                  ...val,
                };
              }
              return contact;
            }
          );

          setContacts(updatedContacts);
          setContactIndex(null);
        }
      } else {
        setContacts((prev: any) => {
          // ensure prev is iterable; default to empty array if undefined/null
          const updated = prev ? [...prev, val] : [val];
          return updated;
        });
      }

      setLoading(false);
      onClose();
    }, 1000);
  };

  useEffect(() => {
    if (editData) {
      setValue("first_name", editData?.first_name);
      setValue("last_name", editData?.last_name);
      setValue("title", editData?.title);
      setValue("phone", editData?.phone);
      setValue("email", editData?.email);
      setMethodContact(editData?.preferred_method_of_contact);
    }
  }, [editData, setValue]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        autoComplete="off"
        name="dependencies"
      >
        <div className="modalWrapper addContactModal">
          <div className="modal_header">
            <div className="title">
              <h3> {editData ? "Edit contact" : "Add new contact"} </h3>
            </div>
          </div>

          <div className="modal_content">
            <Row gutter={16}>
              <Col span={12}>
                <InputField
                  fieldName="first_name"
                  label="First name"
                  control={control}
                  iProps={{
                    placeholder: "Enter first name",
                  }}
                  isRequired
                  rules={{
                    required: "First name is required.",
                  }}
                  validate={errors.first_name && "error"}
                  validMessage={errors.first_name && errors.first_name.message}
                />
              </Col>

              <Col span={12}>
                <InputField
                  fieldName="last_name"
                  label="Last name"
                  control={control}
                  iProps={{
                    placeholder: "Enter last name",
                  }}
                  isRequired
                  rules={{
                    required: "Last name is required.",
                  }}
                  validate={errors.last_name && "error"}
                  validMessage={errors.last_name && errors.last_name.message}
                />
              </Col>
              <Col span={24}>
                <InputField
                  fieldName="title"
                  label="Title"
                  control={control}
                  iProps={{
                    placeholder: "Enter title",
                  }}
                  // isRequired
                  // rules={{
                  //   required: "Title name is required.",
                  // }}
                  // validate={errors.title && "error"}
                  // validMessage={errors.title && errors.title.message}
                  tooltipTitle="A job title or their role in the process (e.g. “Property manager”, “Owner”)"
                />
              </Col>
              <Col span={12}>
                <InputPhone fieldName="phone" label="Phone" control={control} />
              </Col>
              <Col span={12}>
                <InputField
                  fieldName="email"
                  label="Email"
                  control={control}
                  iProps={{
                    placeholder: "Enter email",
                  }}
                  rules={{
                    validate: (val: string) => {
                      if (!val) return true;
                      const value = val.trim();
                      const regex =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                      return (
                        regex.test(value) ||
                        "Please enter a valid email address."
                      );
                    },
                  }}
                  validate={errors.email && "error"}
                  validMessage={errors.email && errors.email.message}
                />
              </Col>
              <Col span={24} style={{ display: "flex" }}>
                <div style={{ fontWeight: "500" }}>
                  Preferred method of contact:
                </div>

                <div
                  className="preferredMethodRadio"
                  style={{ paddingLeft: "16px" }}
                >
                  <Radio.Group
                    onChange={(e) => setMethodContact(e.target.value)}
                    value={methodContact}
                  >
                    <Radio value="any">Any</Radio>
                    <Radio value="phone">Phone</Radio>
                    <Radio value="email">Email</Radio>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
          </div>

          <div className="modal_footer" style={{ justifyContent: "flex-end" }}>
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="mint-btn"
              // disabled={!isDirty || !isValid}
            >
              {editData ? "Save changes" : "Add contact"}
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
}
